import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Box } from '@material-ui/core';
import './Contact.css';
import { Link } from 'react-router-dom';
import config from '../../config';

const LOGO_SRC = 'https://ia.intelladapt.ai/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo.bb151063.png&w=256&q=75';

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [captchaA, setCaptchaA] = useState(getRandomInt(1, 10));
  const [captchaB, setCaptchaB] = useState(getRandomInt(1, 10));
  const [captchaInput, setCaptchaInput] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!name || !email || !message) {
      setError('Please fill in all fields.');
      return;
    }
    if (parseInt(captchaInput, 10) !== captchaA + captchaB) {
      setError('Incorrect answer to the spam check.');
      setCaptchaA(getRandomInt(1, 10));
      setCaptchaB(getRandomInt(1, 10));
      setCaptchaInput('');
      return;
    }
    try {
      const response = await fetch(`${config.API_BASE}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message })
      });
      const data = await response.json();
      if (data.success) {
        setSuccess('Thank you for your message!');
        setName('');
        setEmail('');
        setMessage('');
      } else {
        setError(data.error || 'Failed to send message.');
      }
    } catch (err) {
      setError('Failed to send message.');
    }
    setCaptchaA(getRandomInt(1, 10));
    setCaptchaB(getRandomInt(1, 10));
    setCaptchaInput('');
  };

  return (
    <div>
      <header className="landing-header">
        <img src={LOGO_SRC} alt="Learning Strategy Logo" className="landing-logo-img" />
        <nav className="landing-nav">
          <Link to="/">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/login" className="landing-nav-login-btn">Login</Link>
        </nav>
      </header>
      <Container maxWidth="sm" className="contact-container">
        <Typography variant="h4" align="center" gutterBottom>Contact Us</Typography>
        <form onSubmit={handleSubmit} className="contact-form">
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            margin="normal"
            value={name}
            onChange={e => setName(e.target.value)}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <TextField
            label="Message"
            variant="outlined"
            fullWidth
            margin="normal"
            multiline
            rows={4}
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          <Box display="flex" alignItems="center" mt={2} mb={2}>
            <Typography variant="body1" style={{ marginRight: 12 }}>
              Spam check: What is {captchaA} + {captchaB}?
            </Typography>
            <TextField
              variant="outlined"
              size="small"
              value={captchaInput}
              onChange={e => setCaptchaInput(e.target.value)}
              style={{ width: 80 }}
            />
          </Box>
          {error && <Typography color="error" align="center">{error}</Typography>}
          {success && <Typography color="primary" align="center">{success}</Typography>}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            className="contact-submit"
          >
            Send Message
          </Button>
        </form>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          style={{ marginTop: 16 }}
          onClick={() => window.location.href = '/'}
        >
          Back to Home
        </Button>
      </Container>
    </div>
  );
}

export default Contact; 